import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiCall_domain } from "../api";
import axios from "axios";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

function OrganList(props) {
  const [organ, setOrgan] = useState(false);
  const [name, setName] = useState(null);
  const classes = useStyles();
  const [state, setState] = useState({
    bottom: false,
  });
  const [slots, setSlots] = useState([]);

  const [sort_options, setSort_options] = useState([
    { id: 2, name: "ارزان ترین" },
    { id: 1, name: "گران ترین " },
    { id: 4, name: "جدید ترین" },
    { id: 5, name: "پرفروش ترین" },
    { id: 3, name: "پر بازدید ترین" },
  ]);

  useEffect(() => {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/contracts`, {
        headers: Headers,
      })
      .then((res2) => {
        setSlots(Object.values(res2.data.data));
      });
  }, []);

  const changeOrgan = (e) => {
    props.handleOrgan(parseInt(e.target.value));
    setName(e.target.name);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    setOrgan(true);
    if (open === true) {
    }
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div className="cutimizedSpaan">
          <span className="sorTitle">انتخاب ارگان</span>
        </div>
        <RadioGroup
          defaultValue={`${props.address_idd}`}
          onChange={changeOrgan}
        >
          {organ === true
            ? slots.map((item) => (
                <>
                  <FormControlLabel
                    value={`${item.id}`}
                    control={<Radio />}
                    label={`${item.organ_name}`}
                    name={item.organ_name}
                  />
                </>
              ))
            : props.organSort === true
            ? sort_options.map((item) => (
                <FormControlLabel
                  value={`${item.id}`}
                  control={<Radio />}
                  name={item.name}
                  label={`${item.name}`}
                />
              ))
            : ""}
        </RadioGroup>
      </List>
    </div>
  );
  //functions

  return (
    <>
      <div className="sortPopUp_wrapper">
        <div className="sortContain">
          <div className="radioButton">
            {["bottom"].map((anchor) => (
              <React.Fragment key={anchor}>
                <>
                  <div
                    className="anotherVendors installmentsOr"
                    onClick={toggleDrawer(anchor, true)}
                  >
                    {name !== null ? name : "ارگان مورد نظر را انتخاب کنید"}
                    <img src="/public/assets/icons/Downarrow.svg" alt="ایکون" />
                  </div>
                  <Drawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                  >
                    {list(anchor)}
                  </Drawer>
                </>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
export default OrganList;
